import Vue from 'vue'
import Router from 'vue-router'
import CelebPage from './views/celebPage.vue'
import Home from './views/Home.vue'
import ProductPage from './views/ProductPage.vue'
import ApolloExample from './views/ApolloExample.vue'

// import firebase from 'firebase'

Vue.use(Router)

let router = new Router({

    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                bcLinkText: 'Home Page'
            },
        },
        {
            path: '/apollo',
            name: 'apollo',
            component: ApolloExample,
            meta: {
                bcLinkText: 'Apollo Example'
            },
        },
        {
            path: '/celeb-page',
            name: 'celebPage',
            component: CelebPage,
            meta: {
                bcLinkText: "Celeb Page"
            }
            // ,children: [{
            //     path: ':id',
            //     name: 'productPage',
            //     component: ProductPage,
            //     meta: {
            //         bcDynamic: true,
            //         bcGetter: 'activeCeleb', // <breadcrumb> will use this getter to get the user from vuex
            //         bcLinkText: user => user.celebID.birthName, // once we have the user, we use this function to format the LinkText dnynamically,
            //         bcLoadingText: 'Loading Username...' // This will be shown while Data is loading
            //     },
            // }]
        },
        {
            path: '/product-page',
            name: 'productPage',
            component: ProductPage,
            meta: {
                bcLinkText: 'Product Page'
            },
        }
    ]
})

export default router
